<template>
  <div class="iframe-container">
    <vcl-facebook  v-if="link.length==0" style="margin: 20px"></vcl-facebook>
    <iframe v-else :src="link" frameborder="0" class="responsive-iframe"></iframe>
    <app-footer></app-footer>
  </div>

</template>

<script>
// @ is an alias to /src


import axios from "axios";
import {mapGetters} from 'vuex'
import appHeader from '../views/_header'
import appFooter from '../views/_footer'
import { VclFacebook, VclCode,VclTwitch,VclTable } from 'vue-content-loading';

export default {
  name: 'games',
  components: {
    appHeader,
    appFooter,
    VclFacebook,
    VclCode,
    VclTable,
    VclTwitch,
  },
  data () {
    return {
      show: true,
      ex4: ['red', 'indigo', 'orange', 'primary', 'secondary', 'success', 'info', 'warning', 'error', 'red darken-3', 'indigo darken-3', 'orange darken-3'],
      games:[],
      url:'https://sharjtosharj.com/soccerp/',
      pageloading: false,
      loading: false,
      teamizban:[],
      teammihman:[],
      zamanbazi:[],
      tiks:[],
      link:'',
      javab:[],
      colors:[],
      tikha: Array(61).fill('m'),
      mabcheck: Array(61).fill(0),
      serial:0,
      mablagh:0,
      code_n:0,
      noe:0,
      noefarsi:'-',
      ofoghi:true,
    }
  },
  mounted() {
    let self = this;
    self.link=this.baseUrl+'/ons7m.aspx'
    self.noe=self.$route.params.noe;
    console.log(self.link);
    if    (self.noe == '9') self.noefarsi=' سیزده بازی ';
    else  if(self.noe == '4') self.noefarsi=' چهارده بازی ';
    else  if(self.noe == '5') self.noefarsi=' پانزده بازی ';
    else  if(self.noe == '3') self.noefarsi=' شانزده بازی نشاط ';
    else  if(self.noe == '16') self.noefarsi=' شانرده بازی گنجینه ';
    else  if(self.noe == '7') self.noefarsi=' هفده بازی ';
    else  if(self.noe == '30') self.noefarsi=' بیست بازی ';

   // self.getformview();
  },
  computed: {
    ...mapGetters(['baseUrl', "auth"]),
  },
  methods:{
    randomColor() {
      const r = () => Math.floor(400 * Math.random());

      return `rgb(${r()}, ${r()}, ${r()})`;
    },

    getformview(){
      let self = this;
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }
      let formData = new FormData();
      formData.append("token", self.appToken);
      formData.append("code_shakhs", self.$store.getters.auth.data.user_id);
      formData.append("noe", "5");//self.$route.params.noe);

      axios.post(this.baseUrl+'/live15m.aspx', formData, config)
          .then(function (r) {
            //console.log(r.data);
            if(r.data.data.result=="1"){

              self.teamizban=r.data.data.teammizban;
              self.teammihman=r.data.data.teammihman;
              self.codebazi =r.data.data.codebazi;
              self.zamanbazi=r.data.data.zamanbazi;
              self.javab=r.data.data.javab;
              self.noe=r.data.data.noe;
              self.pageloading=true;

              /*r.data.data.teammizban.forEach(async (item, index) => {
                const url = `http://data.7m.com.cn/goaldata/js/${r.data.data.codebazi[index]}.js`;
                try {
                  const response = await fetch(url);
                  const data = await response.text();
                  const match = data.match(/var score="(.+?)";[\s\S]*?var st=(\d+);[\s\S]*?var start_time="(.+?)"/);
                  if (match) {
                    const score = match[1];
                    const st = parseInt(match[2], 10);
                    const startTime = match[3].split(',').map(Number);

                    const dateString = r.data.data.zamanbazi[index];
                    const currentTime = dateString.split(',').map(Number);

                    const startTimeMillis = new Date(...startTime).getTime();
                    const currentTimeMillis = new Date(...currentTime).getTime();
                    const elapsedTime = currentTimeMillis - startTimeMillis;

                    const elapsedTimeVariable = elapsedTime / (1000 * 60 ); // زمان گذشته به دقیقه

                    // اینجا می‌توانید مقادیر score، st و elapsedTimeVariable را استفاده کنید
                    console.log(`Score: ${score}, ST: ${st}, Elapsed Time: ${elapsedTimeVariable} hours`);
                  } else {
                    console.error(`Error parsing data from ${url}`);
                  }
                } catch (error) {
                  console.error(`Error fetching ${url}: ${error}`);
                }
              });*/

            }
            else
            {self.helperToast({
              show:true,
              text:r.data.message,
              color:'red'
            });

            }
            self.loading = false;
          });


      self.page=self.page+10;

    },


  },
  watch:{}
}
</script>

<style>
iframe {
  zoom: 0.5;
}

.product-slider .v-btn--active{
  background: transparent
}
.product-slider .v-progress-linear {
  height: 2px  !important;
}
.search-bars{
  display: flex;
  align-items: center;
  border: solid 1px #dbd9d9;
  border-radius: 5px;
  height: 30px;
  width: 100%;
  padding-right:10px;
  background: #fff;
  font-size: 14px;
  transition: all 0.3s ease;
  margin-right: 5px;
}
.search-bars:focus{
  outline: none;
  border: solid 1px transparent;
  box-shadow: 0px 0px 4px -1px rgb(0 0 0 / 20%);
}
.product-property li{
  list-style: none;
  display: inline-block;
  width: 100%;
}
.product-property li > .product-param-list,
.product-property li > .product-value-list{
  /* background: #f6f6f6; */
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 7px 10px 7px 7px;
  margin-bottom: 15px;
  display: inline-block;
  border-bottom: solid 1px #ddd;
}
.product-property li > .product-param-list{
  width: 35%;
  margin-left: 5%;
  font-size: 13px;
  color:black;
  vertical-align: top;
  border-bottom: none;
}
.product-property li > .product-value-list{
  width: 60%;
  font-size: 12px;
}
.product-property li:last-child .product-value-list{
  border-bottom: none;
}
.styled-table {
  border-collapse: collapse;
  font-size: 0.8em;
  min-width: 100%;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);

}
.styled-table thead tr {
  background-color: #531fad;
  color: #ffffff;
  text-align: center;
}
.styled-table th,
.styled-table td {
  padding: 12px 15px;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}

.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}

.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #009879;
}
.styled-table tbody tr.active-row {
  font-weight: bold;
  color: #009879;
}
.iframe-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.responsive-iframe {
  width: 100%;
  height: 100%;
  border: none;

  transform-origin: 0 0; /* اندازه محتویات داخل iframe کوچک می‌شود */
}
</style>
